import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {Layout} from '../Common';
import PrivateRoute from '../Common/PrivateRoute';
import SideNavBar from '../Common/SideNavBar';
import CouponRegistration from './CouponRegistration';
import ProductsGuide from './ProductsGuide';
import Purchase from './Purchase/index';

const menus = [
  {path: '/products/guide', name: 'PC방 상품안내'},
  {path: '/products/purchase', name: '상품 구매하기'},
  {path: '/products/couponRegistration', name: '쿠폰 코드 등록'},
];

class Products extends Component {
  render() {
    return (
      <Layout>
        <SideNavBar title="상품안내/구매/쿠폰" menus={menus} />
        <Route path="/products/guide" component={ProductsGuide} />
        <PrivateRoute path="/products/couponRegistration" component={CouponRegistration} />
        <PrivateRoute path="/products/purchase" component={Purchase} />
      </Layout>
    );
  }
}
export default Products;
